import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";

import { RootState } from "@/interfaces/store/root-state";
import { globalLoadingModule } from "@/store/global-loading-module";
import { serviceModule } from "@/store/service-module";

/**
 * ストア・オプション
 */
export const rootStoreOptions: StoreOptions<RootState> = {
  state: {
    version: "1.0.0",
  },
  mutations: {},
  getters: {},
  actions: {},
  modules: {
    globalLoading: globalLoadingModule,
    service: serviceModule,
  },
};

Vue.use(Vuex);
export const rootStore = new Vuex.Store<RootState>(rootStoreOptions);
